import clsx from 'clsx';
import PropTypes from 'prop-types';
import Label from '../Label';

const AvatarHeading = ({
  imageSrc,
  imageTitle,
  title,
  subTitle,
  className,
  children,
  doShowCruiseTourLabel,
}) => (
  <div className={clsx('flex grid-flow-col gap-5 text-left', className)}>
    <div className="rounded-full border-2 h-12 w-12 pt-2 align-middle flex-shrink-0">
      <img
        className="align-middle"
        src={imageSrc}
        title={imageTitle}
        alt={imageTitle}
      />
    </div>
    <div>
      <div className="font-bold sm:text-sm xl:text-lg">
        {title}
        {doShowCruiseTourLabel && (
          <span className="ml-2"><Label text="Cruise Tour" level="themeWithBg" inline /></span>
        )}
      </div>
      {subTitle && (
      <div className="sm:text-xs xl:text-sm">
        {subTitle}
      </div>
      )}
      <div className="sm:text-xs xl:text-sm flex flex-wrap">
        {children}
      </div>
    </div>
  </div>
);

AvatarHeading.propTypes = {
  imageSrc: PropTypes.string,
  imageTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  doShowCruiseTourLabel: PropTypes.bool,
};

AvatarHeading.defaultProps = {
  imageSrc: undefined,
  className: undefined,
  children: undefined,
  doShowCruiseTourLabel: false,
  subTitle: undefined,
};

export default AvatarHeading;
